import { isPageReloadingAfterError } from '@common/components/Notifications/resetAfterError';
import { useEffect, useRef, useState } from 'react';
import {
  readWizardSnapshot,
  removeWizardSnapshot,
  saveWizardSnapshot,
  WizardSnapshot,
} from '../helpers/wizardSnapshot';

export const useRestoredWizardSnapshot = () => {
  const [snapshot, setSnapshot] = useState(readWizardSnapshot);
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    removeWizardSnapshot();
    setHasMounted(true);
  }, []);

  return {
    snapshot,
    isRestoring: hasMounted && !!snapshot,
    clearSnapshot: () => setSnapshot(null),
  };
};

type SaveSnapshotOptions = {
  pendingSnapshot: WizardSnapshot | null;
  isPackageAddingOrAdded: () => boolean;
  getSnapshot: () => WizardSnapshot;
};

export const useSaveWizardSnapshotOnPageHide = (options: SaveSnapshotOptions) => {
  const latestOptions = useRef(options);
  latestOptions.current = options;

  useEffect(() => {
    const handlePageHide = (event: PageTransitionEvent) => {
      if (event.persisted || isPageReloadingAfterError()) return;
      const { pendingSnapshot, isPackageAddingOrAdded, getSnapshot } = latestOptions.current;
      if (pendingSnapshot) {
        saveWizardSnapshot(pendingSnapshot);
      } else if (!isPackageAddingOrAdded()) {
        saveWizardSnapshot(getSnapshot());
      }
    };

    window.addEventListener('pagehide', handlePageHide);

    return () => {
      window.removeEventListener('pagehide', handlePageHide);
    };
  }, []);
};
